import { MShopAppProductDetailF } from '../../../../MShop/App/ProductDetail/F/Function/module/MShopAppProductDetailF.js';
import {
  productDetailSelectedCharacterChanged,
  productDetailSelectedOptionGroupChanged,
} from '../../../../MShop/App/ProductDetail/CustomEvent/custom-event.ts';
import { MShopUtilF } from '../../../../MShop/Util/F/Function/module/MShopUtilF.js';
import { MuiF } from '../../../../Mui/F/Function/module/MuiF.js';
import { NessCoreTmplS } from '../../../../Ness/Core/S/Tmpl/module/NessCoreTmplS.js';
import { NessLabsFrameF } from '@modules/NessLabs/Frame/F';
import { NessModalF } from '../../../NessModal/F/Function/module/NessLabsNessModalF.js';
import { smoothScrollTopAndRemember, smoothScrollToSaved } from '../../../Setting/F/Function/scroll.js';
import { warningModalBody, myCharactersHelpModalBody } from '../../S/Tmpl/myCharactersHelpModalBody.js';
import { NessLabsMyCharactersMuiF } from '../Mui/module/NessLabsMyCharactersMuiF.js';
import { go, map, html } from 'fxjs/es';
import { $delegate, $data } from 'fxdom/es';
import { NessLabsFrameS } from '@modules/NessLabs/Frame/S';

const WARNING_TYPES = {
  WIDTH: {
    title:
      '선택하신 캐릭터는 가로 폭이 넓어 제품 조립시 다른 캐릭터를 가릴 수 있습니다.<br />상품 수령 후 캐릭터를 조립할 때 앞쪽이 아닌 뒤쪽 홈에 조립하는 것을 추천드립니다.',
    img_src: '//s3.marpple.co/files/u_193535/2025/11/original/ba85a2dc21e8cc012aca3c75f97fb2caf5f093534.png',
  },
  HEIGHT: {
    title: '선택하신 캐릭터는 세로 길이가 길어 액자 1~5번 위치에만 배치가 가능합니다',
    img_src: '///s3.marpple.co/files/u_193535/2025/12/original/8a8d08995492a72d57a7ed97a84171c38d48ec1b3.png',
  },
  WIDTH_HEIGHT: {
    title:
      '선택하신 캐릭터는 세로 길이가 길어 액자 1~5번 위치에만 배치가 가능합니다.<br />또한, 가로 폭이 넓은 캐릭터의 경우, 다른 캐릭터를 가릴 수 있어<br />상품 수령 후 캐릭터를 조립할 때 앞쪽이 아닌 뒤쪽 홈에 조립하는 것을 추천드립니다.',
    img_src: '//s3.marpple.co/files/u_193535/2025/12/original/1892ad7370cb7c943dac0d54155ec7fa64778a295.png',
  },
  BOTTOM_OVERFLOW: {
    title:
      '선택하신 캐릭터는 아크릴 스탠드 받침대 위치로 인해<br>발 아래 영역은 인쇄되지 않으니, 구매 시 참고 부탁드립니다. ',
    img_src: '//s3.marpple.co/files/u_193535/2025/11/original/8dfc59c99d1f750682f07ea7438ae8a9e6737a061.png',
  },
  WIDTH_MO: {
    title:
      '선택하신 캐릭터는 가로 폭이 넓어 제품 조립시 다른 캐릭터를 가릴 수 있습니다.<br />상품 수령 후 캐릭터를 조립할 때 앞쪽이 아닌 뒤쪽 홈에 조립하는 것을 추천드립니다.',
    img_src: '//s3.marpple.co/files/u_193535/2025/11/original/336e0013f48aabe97fa5254d5ebba3ed4d8b1d4b5.png',
    width: 288,
  },
  HEIGHT_MO: {
    title: '선택하신 캐릭터는 세로 길이가 길어 액자 1~5번 위치에만 배치가 가능합니다',
    img_src: '//s3.marpple.co/files/u_193535/2025/12/original/2ee0dfcd365bb1556537dc00c18a9b65d3a9f1464.png',
    width: 288,
  },
  WIDTH_HEIGHT_MO: {
    title:
      '선택하신 캐릭터는 세로 길이가 길어 액자 1~5번 위치에만 배치가 가능합니다.<br />또한, 가로 폭이 넓은 캐릭터의 경우, 다른 캐릭터를 가릴 수 있어<br />상품 수령 후 캐릭터를 조립할 때 앞쪽이 아닌 뒤쪽 홈에 조립하는 것을 추천드립니다.',
    img_src: '//s3.marpple.co/files/u_193535/2025/11/original/98dd3edcc5b0cbb33a14c2c1e177af3a48c95de71.png',
    width: 288,
  },
  BOTTOM_OVERFLOW_MO: {
    title:
      '선택하신 캐릭터는 아크릴 스탠드 받침대 위치로 인해발 아래 영역은 인쇄되지 않으니, 구매 시 참고 부탁드립니다. ',
    img_src: '//s3.marpple.co/files/u_193535/2025/11/original/1ef2293bd131e68bb2e119d1e528e8c94df360f91.png',
    width: 288,
  },
};

const showWarningModal = (warning_type_key, character_names) => {
  const warning_type = MShopUtilF.isMobile()
    ? WARNING_TYPES[`${warning_type_key}_MO`]
    : WARNING_TYPES[warning_type_key];

  return NessModalF.openNessModal({
    data: {
      body: warningModalBody({
        ...warning_type,
        character_names,
      }),
      buttons: [{ label: 'Check', type: 'confirm', class: 'confirm' }],
    },
    frameOptions: {
      is_modal: true,
      always_remove: true,
    },
  });
};

const generateMyCharacters = (frame_characters) => {
  NessLabsFrameF.SelectedOptionGroupForFrameCharacter.setBpOptionOutputForCharacter(
    go(frame_characters, map(NessLabsFrameS.NessFrameProduct.pickObject)),
  );
  productDetailSelectedOptionGroupChanged.dispatch();
  productDetailSelectedCharacterChanged.dispatch();
};

export const openMyCharacters = async (characters, selected_characters) => {
  let saved_position = window.pageYOffset;
  if (MShopUtilF.isMobile()) {
    if (window.visualViewport) {
      if (window.visualViewport.height !== document.documentElement.clientHeight) {
        saved_position = await smoothScrollTopAndRemember();
      }
    }
    // scrollTo(0, 0)도 header로 인해 최상단으로 이동하지 않아서 한번 더 처리
    window.scrollTo({
      top: -1,
      behavior: 'smooth',
    });
  }

  return MuiF.openFrame(NessLabsMyCharactersMuiF.frame, async (frame, page, [tab]) => {
    const is_mobile = MShopUtilF.isMobile();
    let selected_c_ids = selected_characters?.length
      ? selected_characters.map((selected) =>
          characters.findIndex(
            (character) =>
              character.gcid === selected.gcid &&
              character.guid === selected.guid &&
              character.world_id === selected.world_id,
          ),
        )
      : [];
    frame.title = MShopUtilF.isMobile()
      ? html`<div class="character-select-title">
          Character Select <button class="characters-selector__help">${NessCoreTmplS.getHelpIcon()}</button>
        </div>`
      : 'Character Select';
    frame.hide_frame_button_type = 'X';
    frame.always_remove = true;
    frame.animation = true;
    frame.prev_frame_show = true;
    frame.is_modal = !is_mobile;
    MShopAppProductDetailF.makePdFormToSticky(true);

    frame.showing = () => {
      if (is_mobile) {
        window.scrollTo({
          top: 1,
          behavior: 'smooth',
        });
      }
    };
    frame.closed = async () => {
      MShopAppProductDetailF.makePdFormToSticky(false);
      if (is_mobile) {
        await smoothScrollToSaved(saved_position);
      }
    };

    tab.makeData = () => characters;
    tab.appended = (tab_el) => {
      if (selected_c_ids.length) {
        selected_c_ids.forEach((id, idx) => {
          const $target = document.querySelector(`.character-item[data-no="${id}"]`);
          if (!$target) return;
          $target.classList.add('selected');
          const $order = $target.querySelector('.selected-order');
          $order.innerHTML = idx + 1;
        });
      }

      NessModalF.openNessModal({
        data: {
          body: myCharactersHelpModalBody(MShopUtilF.isMobile()),
          buttons: [{ label: 'Check', type: 'confirm', class: 'confirm' }],
        },
        frameOptions: {
          is_modal: true,
          always_remove: true,
        },
      });

      go(
        tab_el,
        $delegate('click', '.cancel-button', () => MuiF.removeFrame()),
        $delegate('click', '.generate-button', async () => {
          let use_width_warning = false;
          let use_height_warning = false;
          let has_bottom_overflow = false;
          const target_characters = new Set();
          const bottom_overflow_characters = new Set();

          const frame_characters = selected_c_ids.map((id, idx) => {
            const $target = document.querySelector(`.character-item[data-no="${id}"]`);
            const character = $data($target);
            if (character.checker.warning.width) {
              use_width_warning = true;
              target_characters.add(character.gc_name);
            }

            if (character.checker.warning.height) {
              if (idx < 5) character.checker.warning.height = false;
              else {
                use_height_warning = true;
                target_characters.add(character.gc_name);
              }
            }
            if (character.checker.warning.has_bottom_overflow) {
              has_bottom_overflow = true;
              bottom_overflow_characters.add(character.gc_name);
            }

            return character;
          });
          if (has_bottom_overflow) {
            const result = await showWarningModal('BOTTOM_OVERFLOW', [...bottom_overflow_characters]);
            if (!result) return;
          }
          if (use_width_warning && use_height_warning) {
            const result = await showWarningModal('WIDTH_HEIGHT', [...target_characters]);
            if (!result) return;
          } else if (use_height_warning) {
            const result = await showWarningModal('HEIGHT', [...target_characters]);
            if (!result) return;
          } else if (use_width_warning) {
            const result = await showWarningModal('WIDTH', [...target_characters]);
            if (!result) return;
          }
          generateMyCharacters(frame_characters);
          MuiF.removeFrame();
        }),
        $delegate('click', '.characters-selector__refresh', () => {
          go(
            document.querySelectorAll('.character-item.selected'),
            map(($item) => $item.classList.remove('selected')),
          );
          selected_c_ids = [];
        }),
        $delegate('click', '.characters-selector__help', () => {
          NessModalF.openNessModal({
            data: {
              body: myCharactersHelpModalBody(MShopUtilF.isMobile()),
              buttons: [{ label: 'Check', type: 'confirm', class: 'confirm' }],
            },
            frameOptions: {
              is_modal: true,
              always_remove: true,
            },
          });
        }),
        $delegate('click', '.character-item', ({ currentTarget: ct }) => {
          if (ct.classList.contains('disabled')) return;
          const is_selected = ct.classList.contains('selected');
          const target_no = Number(ct.dataset.no);
          const target_idx = selected_c_ids.indexOf(target_no);
          if (target_idx === -1) {
            if (selected_c_ids.length >= 10)
              return MShopUtilF.isMobile()
                ? $.alert(ET('labs::my_characters::alert::alert_1_mo'))
                : MShopUtilF.popToastMsg(ET('labs::my_characters::alert::alert_1'), 'info', {
                    color: 'black',
                  });
            selected_c_ids.push(target_no);
          } else selected_c_ids.splice(target_idx, 1);

          ct.classList.toggle('selected', !is_selected);
          selected_c_ids.forEach((id, idx) => {
            const $target = document.querySelector(`.character-item[data-no="${id}"]`);
            if (!$target) return;
            const $order = $target.querySelector('.selected-order');
            $order.innerHTML = idx + 1;
          });
        }),
        $delegate('contextmenu', '.character-item', ({ currentTarget }) => {
          if (!window.ENV.is_prod_real) {
            const uc = NessLabsFrameS.NessFrameProduct.pickObject($data(currentTarget));
            $.alert(JSON.stringify(uc));
          }
        }),
      );
    };
  });
};
